<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="human-risk-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="6"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <!-- Central identity with scoring ring -->
    <!-- Outer scoring ring -->
    <circle
      cx="100"
      cy="75"
      r="38"
      fill="none"
      stroke="#ede9fe"
      stroke-width="4"
    />
    <circle
      cx="100"
      cy="75"
      r="38"
      fill="none"
      stroke="#7c3aed"
      stroke-width="4"
      stroke-dasharray="150 220"
      stroke-linecap="round"
      transform="rotate(-90 100 75)"
      class="ring"
    />

    <!-- Inner ring -->
    <circle
      cx="100"
      cy="75"
      r="26"
      fill="#f5f3ff"
      stroke="#c4b5fd"
      stroke-width="1"
    />

    <!-- Identity center -->
    <g filter="url(#human-risk-glow)">
      <circle cx="100" cy="75" r="16" fill="#7c3aed" />
      <circle cx="100" cy="71" r="5" fill="white" />
      <path d="M93 82 Q93 76 100 76 Q107 76 107 82" fill="white" />
    </g>
  </svg>
</template>

<style scoped>
@keyframes ring {
  0%,
  100% {
    stroke-dasharray: 150 220;
  }
  50% {
    stroke-dasharray: 170 220;
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
.ring {
  animation: ring 4s ease-in-out infinite;
}
.pulse {
  animation: pulse 2s ease-in-out infinite;
}
.delay1 {
  animation-delay: 0.5s;
}
.delay2 {
  animation-delay: 1s;
}
.delay3 {
  animation-delay: 1.5s;
}
</style>
